export { DMS_MODULE } from '../constants';
export const NAME = 'StockAgingAnalysis';
export const API_NAME = 'StockAgingAnalysis';
export const EXPORT_FILE_NAME = 'StockAgingAnalysis.xlsx';
export const CRUMB_LABEL_KEY = 'StockAgingAnalysis';


export type SestavaButton = { labelKey: string, routeName: string, api: string, permission: number };
